import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenTimerService {

  
  
  private popupTimer: any = null;
  popupEvent = new Subject<void>();

  schedulePopup(expireTime: string | number) {
    const currentTime = new Date().getTime();
    const expiry = new Date(expireTime).getTime();
    const remainingTime = expiry - currentTime;

    if (this.popupTimer) clearTimeout(this.popupTimer);

    this.popupTimer = setTimeout(() => {
      this.popupEvent.next();  
    }, remainingTime);
  }

  cancelPopup() {
    if (this.popupTimer) {
      clearTimeout(this.popupTimer);
      this.popupTimer = null;
    }
  }
}
